import { splitContentWithSkillSlugs } from "./selectedSkillContext";

/** Class on the `<span>` wrapping each `/slug` token; the user bubble styles it. */
export const SCOUT_SKILL_SLUG_CLASS = "scout-skill-slug";

type MarkdownNode = {
  type: string;
  value?: string;
  children?: MarkdownNode[];
  data?: { hName?: string; hProperties?: Record<string, string> };
};

// Code and link text stay literal: a `/path` there is not a skill invocation.
const SKIPPED_PARENT_TYPES = new Set(["code", "inlineCode", "link", "linkReference"]);

function splitTextNode(value: string): MarkdownNode[] {
  return splitContentWithSkillSlugs(value).map((part) =>
    part.type === "text"
      ? { type: "text", value: part.value }
      : {
          type: "scoutSkillSlug",
          data: { hName: "span", hProperties: { className: SCOUT_SKILL_SLUG_CLASS } },
          children: [{ type: "text", value: part.value }],
        }
  );
}

function decorate(node: MarkdownNode): void {
  if (!node.children) {
    return;
  }
  node.children = node.children.flatMap((child) => {
    if (child.type === "text" && child.value) {
      return splitTextNode(child.value);
    }
    if (!SKIPPED_PARENT_TYPES.has(child.type)) {
      decorate(child);
    }
    return [child];
  });
}

/** Remark plugin that wraps `/slug` tokens in a classed span (display only). */
export function remarkScoutSkillSlugs() {
  return (tree: MarkdownNode) => decorate(tree);
}
